import { render, staticRenderFns } from "./DIDSettings.vue?vue&type=template&id=b25084f0&scoped=true&"
import script from "./DIDSettings.vue?vue&type=script&lang=js&"
export * from "./DIDSettings.vue?vue&type=script&lang=js&"
import style0 from "./DIDSettings.vue?vue&type=style&index=0&id=b25084f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25084f0",
  null
  
)

export default component.exports